<template>
  <div class="forgot-component">
    <h2>Forgot password</h2>
    <form @submit.stop.prevent="submit">
      <div class="field">
        <label>email</label>
        <input type="email" name="email" placeholder="Enter email" v-model="email"/>
      </div>
      <div class="actions">
        <button class="main" type="submit">Get new password</button>
        <loader v-if="isLoading" label="" class="loader"></loader>
      </div>
    </form>
  </div>
</template>

<script>
  import Loader from '../Loader.vue'
  import { validateEmail } from '../../lib/utils'

  export default {
    name: 'forgot',
    components: { Loader },
    data() {
      return {
        email: '',
        isLoading: false,
      }
    },
    methods: {
      submit() {
        if (!validateEmail(this.email)) {
          this.$toasted.error('Please enter a valid email address')
          return
        }
        this.isLoading = true
        this.$http.post('user/forgot', { email: this.email }).then(
          () => {
            this.isLoading = false
            this.$router.replace(this.$route.query.redirect || '/')
            this.$toasted.success('New password requested, checkout your mailbox')
          },
          () => {
            this.isLoading = false
            this.$toasted.error('Email not found')
          },
        )
      },
    },
  }
</script>

<style scoped lang="scss">
  .forgot-component {
    width: 600px;
    margin: 40px auto 80px;
  }
  input {
    box-sizing: border-box;
    width: 600px;
    margin-bottom: 20px;
  }
  .actions {
    position: relative;
    margin-bottom: 20px;
  }
  .loader {
    width: 55px;
    position: absolute;
    top: -26px;
    left: 8px;
  }
</style>
